/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.draft-toolbar[_ngcontent-%COMP%]{background-color:#fff;padding:15px 0 35px 10px}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc2xpcHJlc2lzdGFudC9zbGlwcmVzaXN0YW50L2NsaWVudC9zcmMvYXBwL2RyYWZ0LXRvb2xiYXIvZHJhZnQtdG9vbGJhci5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL3J1bm5lci93b3JrL3NsaXByZXNpc3RhbnQvc2xpcHJlc2lzdGFudC9jbGllbnQvc3JjL2FwcC9kcmFmdC10b29sYmFyL2RyYWZ0LXRvb2xiYXIuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/$$_gendir/app/draft-toolbar/draft-toolbar.component.scss.shim.ngstyle.ts